import React from 'react';
import { BaseContainer } from 'src/base/BaseContainer';
import { H1 } from 'src/base/texts/H1';
import { P } from 'src/base/texts/P';
import CreateAccountForm from 'src/components/app/auth/CreateAccountForm';

export const GetStarted = () => (
  <BaseContainer>
    <H1>Welcome to Marble!</H1>
    <P>
      Once your account is created, your virtual rental management team will
      take over your rental operations.
    </P>
    <div style={{ paddingTop: 30 }}>
      <CreateAccountForm />

      <div style={{ paddingTop: 50 }}>
        <P>
          Already have an account? <a href="/login">Login</a>
        </P>
      </div>
    </div>
  </BaseContainer>
);
